import {IResponse, RACARequest} from "../../Request";
import {Dispatch} from "redux";
import {endLoading, startLoading} from "../../../store/slices/loadingSlice";

export interface IPasswordRecoveryVerificationRequest {
  token: string;
  password: string;
}

export default async function(
  dispatch: Dispatch,
  input: IPasswordRecoveryVerificationRequest,
): Promise<IResponse> {
  dispatch(startLoading())

  const request = new RACARequest('auth', 'password-recovery')
    .setData(input);

  const response = await request.makeRequest()

  dispatch(endLoading())
  return response;
}
